module.exports = __webpack_public_path__ + "img/hxjh.a44a98d2.png";